/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {
    SET_CURRENT_CONTENT,
    COMPLETE_QUEUE,
    RESET_QUEUE,
    RESET_MULTIPLE_QUEUES,
} from 'redux/actions/queue_status';

/* ========== ~~~~~~~~~~ CONTENT STATUS : REDUCER ~~~~~~~~~~ ========== */
// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
// utilized in "_container" components

const queueStatus = (state = {}, action) => {
    let newState = JSON.parse(JSON.stringify(state));

    switch (action.type) {
		case COMPLETE_QUEUE:
            newState.currentContent = null;
            newState.queueCompleted = true;
			return newState;
		case RESET_QUEUE:
            newState.currentContent = null;
            newState.queueCompleted = false;
            return newState;
		case SET_CURRENT_CONTENT:
            let isRepeatableQueue = newState.queue.repeatQueue;
            let queueLength = newState.queue.queue.length;
            let curPosition = newState.queue.queue.indexOf(action.contentId);
            let nextContent = curPosition < queueLength || isRepeatableQueue ?
                    newState.queue.queue[(curPosition + 1) % queueLength] : null;
            let nextContentType = nextContent !== null ? newState.queue.contentTypes[nextContent] : null;
            newState.currentContent = action.contentId;
            newState.currentContentType = newState.queue.contentTypes[action.contentId];
            newState.nextContent = nextContent;
            newState.nextContentType = nextContentType;
			return newState;
        default:
			return state;
    }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default queueStatus;
